'use client';

var color = {
  advisa: {
    teal: {
      shade: {
        "100": {
          value: "#EDFFFE",
          type: "color"
        },
        "200": {
          value: "#C0FEFF",
          type: "color"
        },
        "300": {
          value: "#81FBFF",
          type: "color"
        },
        "400": {
          value: "#3AF8FF",
          type: "color"
        },
        "500": {
          value: "#00FFFF",
          type: "color"
        },
        "600": {
          value: "#00E1E2",
          type: "color"
        },
        "700": {
          value: "#00B2B7",
          type: "color"
        },
        "800": {
          value: "#008C91",
          type: "color"
        },
        "900": {
          value: "#04585D",
          type: "color"
        },
        "1000": {
          value: "#1D2731",
          type: "color"
        }
      }
    },
    orange: {
      "400": {
        value: "#FF873D",
        type: "color"
      }
    },
    beige: {
      "100": {
        value: "#F0EBE5",
        type: "color"
      }
    },
    yellow: {
      "600": {
        value: "#FFC600",
        type: "color"
      },
      "700": {
        value: "#D6A600",
        type: "color"
      }
    },
    red: {
      "600": {
        value: "#9F3557",
        type: "color"
      },
      "750": {
        value: "#70144A",
        type: "color"
      }
    }
  },
  neutrals: {
    black: {
      value: "#000",
      type: "color"
    },
    white: {
      value: "#fff",
      type: "color"
    },
    gray: {
      "100": {
        value: "#F4F4F4",
        type: "color"
      },
      "200": {
        value: "#E0E0E0",
        type: "color"
      },
      "300": {
        value: "#D1D1D1",
        type: "color"
      },
      "400": {
        value: "#AEAEAE",
        type: "color"
      },
      "500": {
        value: "#7C7C7C",
        type: "color"
      },
      "600": {
        value: "#525252",
        type: "color"
      },
      "700": {
        value: "#393939",
        type: "color"
      },
      "800": {
        value: "#262626",
        type: "color"
      },
      "900": {
        value: "#161616",
        type: "color"
      },
      "1000": {
        value: "#000000",
        type: "color"
      }
    },
    orange: {
      "100": {
        value: "#fff3e2",
        type: "color"
      },
      "200": {
        value: "#ffe3cc",
        type: "color"
      },
      "300": {
        value: "#ffc79b",
        type: "color"
      },
      "400": {
        value: "#ffa864",
        type: "color"
      },
      "500": {
        value: "#fe8e37",
        type: "color"
      },
      "600": {
        value: "#fe7d1a",
        type: "color"
      },
      "700": {
        value: "#ff7509",
        type: "color"
      },
      "800": {
        value: "#e46400",
        type: "color"
      },
      "900": {
        value: "#cb5700",
        type: "color"
      },
      "1000": {
        value: "#b14900",
        type: "color"
      }
    },
    blue: {
      "100": {
        value: "#e8f0ff",
        type: "color"
      },
      "200": {
        value: "#DCE3FC",
        type: "color"
      },
      "300": {
        value: "#BDCAFA",
        type: "color"
      },
      "400": {
        value: "#9EB1F8",
        type: "color"
      },
      "500": {
        value: "#7F98F6",
        type: "color"
      },
      "600": {
        value: "#607FF4",
        type: "color"
      },
      "700": {
        value: "#4066F1",
        type: "color"
      },
      "800": {
        value: "#2B52D9",
        type: "color"
      },
      "900": {
        value: "#163EC1",
        type: "color"
      },
      "1000": {
        value: "#002baa",
        type: "color"
      }
    },
    purple: {
      "100": {
        value: "#F4EAFF",
        type: "color"
      },
      "200": {
        value: "#DEC9FD",
        type: "color"
      },
      "300": {
        value: "#C8A8FB",
        type: "color"
      },
      "400": {
        value: "#B287F9",
        type: "color"
      },
      "500": {
        value: "#9C66F7",
        type: "color"
      },
      "600": {
        value: "#8645F5",
        type: "color"
      },
      "700": {
        value: "#7126F1",
        type: "color"
      },
      "800": {
        value: "#611AD9",
        type: "color"
      },
      "900": {
        value: "#510EC1",
        type: "color"
      },
      "1000": {
        value: "#4102AA",
        type: "color"
      }
    },
    yellow: {
      "100": {
        value: "#FFFCEB",
        type: "color"
      },
      "200": {
        value: "#EFE4AD",
        type: "color"
      },
      "300": {
        value: "#FEEFA5",
        type: "color"
      },
      "400": {
        value: "#FEE66F",
        type: "color"
      },
      "500": {
        value: "#D6BD38",
        type: "color"
      },
      "600": {
        value: "#AD9200",
        type: "color"
      },
      "700": {
        value: "#A08800",
        type: "color"
      },
      "800": {
        value: "#937E00",
        type: "color"
      },
      "900": {
        value: "#867400",
        type: "color"
      },
      "1000": {
        value: "#7A6800",
        type: "color"
      }
    }
  },
  omalaina: {
    orange: {
      shade: {
        "100": {
          value: "#FFF2E8",
          type: "color"
        },
        "200": {
          value: "#FFDBBF",
          type: "color"
        },
        "300": {
          value: "#FFB780",
          type: "color"
        },
        "400": {
          value: "#FF9B4E",
          type: "color"
        },
        "500": {
          value: "#FC8A30",
          type: "color"
        },
        "600": {
          value: "#FF7000",
          type: "color"
        },
        "700": {
          value: "#F06212",
          type: "color"
        },
        "800": {
          value: "#DC4F13",
          type: "color"
        },
        "900": {
          value: "#993207",
          type: "color"
        },
        "1000": {
          value: "#602005",
          type: "color"
        }
      }
    },
    red: {
      "500": {
        value: "#FF3401",
        type: "color"
      },
      "600": {
        value: "#C00000",
        type: "color"
      },
      "800": {
        value: "#8C0000",
        type: "color"
      }
    },
    green: {
      "450": {
        value: "#07DF1C",
        type: "color"
      }
    },
    brown: {
      "50": {
        value: "#F6EDE6",
        type: "color"
      },
      "100": {
        value: "#E3DAD4",
        type: "color"
      },
      "450": {
        value: "#CFC7C1",
        type: "color"
      },
      "850": {
        value: "#432400",
        type: "color"
      }
    }
  },
  rahalaitos: {
    blue: {
      "800": {
        value: "#2A3C4A",
        type: "color"
      }
    },
    red: {
      "500": {
        value: "#DF202D",
        type: "color"
      }
    },
    green: {
      shade: {
        "100": {
          value: "#F6FFEB",
          type: "color"
        },
        "200": {
          value: "#E1F6CC",
          type: "color"
        },
        "300": {
          value: "#BCF087",
          type: "color"
        },
        "400": {
          value: "#94EC37",
          type: "color"
        },
        "500": {
          value: "#79E00C",
          type: "color"
        },
        "600": {
          value: "#6BD100",
          type: "color"
        },
        "700": {
          value: "#59C119",
          type: "color"
        },
        "800": {
          value: "#4DA518",
          type: "color"
        },
        "900": {
          value: "#3B840E",
          type: "color"
        },
        "1000": {
          value: "#193F02",
          type: "color"
        }
      }
    }
  },
  digifinans: {
    green: {
      "550": {
        value: "#6bd100",
        type: "color"
      }
    },
    red: {
      "50": {
        value: "#FFDEE0",
        type: "color"
      },
      "100": {
        value: "#FDC5C8",
        type: "color"
      },
      "550": {
        value: "#e2002b",
        type: "color"
      }
    },
    blue: {
      shade: {
        "100": {
          value: "#EDF2FF",
          type: "color"
        },
        "200": {
          value: "#BED0FF",
          type: "color"
        },
        "300": {
          value: "#C5CAFF",
          type: "color"
        },
        "400": {
          value: "#9AA3FB",
          type: "color"
        },
        "500": {
          value: "#6864F2",
          type: "color"
        },
        "600": {
          value: "#3631F1",
          type: "color"
        },
        "700": {
          value: "#0D07EA",
          type: "color"
        },
        "800": {
          value: "#000E8E",
          type: "color"
        },
        "900": {
          value: "#00035B",
          type: "color"
        },
        "1000": {
          value: "#02053C",
          type: "color"
        }
      }
    }
  },
  sambla: {
    green: {
      shade: {
        "100": {
          value: "#EDFFF3",
          type: "color"
        },
        "200": {
          value: "#BFEBCD",
          type: "color"
        },
        "300": {
          value: "#81DBA7",
          type: "color"
        },
        "400": {
          value: "#4DCC84",
          type: "color"
        },
        "500": {
          value: "#39BD71",
          type: "color"
        },
        "600": {
          value: "#1AA555",
          type: "color"
        },
        "700": {
          value: "#008539",
          type: "color"
        },
        "800": {
          value: "#01642C",
          type: "color"
        },
        "900": {
          value: "#0D562C",
          type: "color"
        },
        "1000": {
          value: "#023819",
          type: "color"
        }
      }
    },
    blue: {
      "600": {
        value: "#007ACC",
        type: "color"
      }
    },
    red: {
      shade: {
        "100": {
          value: "#FFE8E8",
          type: "color"
        },
        "200": {
          value: "#FFC7C7",
          type: "color"
        },
        "300": {
          value: "#FFB1B1",
          type: "color"
        },
        "400": {
          value: "#FE9198",
          type: "color"
        },
        "500": {
          value: "#F66771",
          type: "color"
        },
        "600": {
          value: "#DF202D",
          type: "color"
        },
        "700": {
          value: "#C31A26",
          type: "color"
        },
        "800": {
          value: "#A4131D",
          type: "color"
        },
        "900": {
          value: "#570014",
          type: "color"
        },
        "1000": {
          value: "#200107",
          type: "color"
        }
      }
    }
  },
  samblagroup: {
    blue: {
      "100": {
        value: "#E7ECED",
        type: "color"
      },
      "400": {
        value: "#4066F1",
        type: "color"
      },
      "550": {
        value: "#2545BB",
        type: "color"
      },
      "900": {
        value: "#002235",
        type: "color"
      },
      shade: {
        "100": {
          value: "#F8F9FA",
          type: "color"
        },
        "200": {
          value: "#ECEFF2",
          type: "color"
        },
        "300": {
          value: "#D6DCE1",
          type: "color"
        },
        "400": {
          value: "#B2BEC7",
          type: "color"
        },
        "500": {
          value: "#889BA8",
          type: "color"
        },
        "600": {
          value: "#697E8E",
          type: "color"
        },
        "700": {
          value: "#546775",
          type: "color"
        },
        "800": {
          value: "#45535F",
          type: "color"
        },
        "900": {
          value: "#3C4750",
          type: "color"
        },
        "1000": {
          value: "#353D45",
          type: "color"
        }
      }
    },
    orange: {
      "450": {
        value: "#F37121",
        type: "color"
      }
    },
    salmon: {
      "50": {
        value: "#FCEDE8",
        type: "color"
      },
      "100": {
        value: "#FCDFD6",
        type: "color"
      },
      "150": {
        value: "#FCCCC0",
        type: "color"
      },
      "250": {
        value: "#F1A997",
        type: "color"
      },
      "300": {
        value: "#E48A73",
        type: "color"
      }
    },
    pink: {
      shade: {
        "100": {
          value: "#FFDDE3",
          type: "color"
        },
        "200": {
          value: "#FFCDD6",
          type: "color"
        },
        "300": {
          value: "#FFBECA",
          type: "color"
        },
        "400": {
          value: "#FF98AB",
          type: "color"
        },
        "500": {
          value: "#FF728B",
          type: "color"
        },
        "600": {
          value: "#FF5574",
          type: "color"
        },
        "700": {
          value: "#F53054",
          type: "color"
        },
        "800": {
          value: "#E90B33",
          type: "color"
        },
        "900": {
          value: "#D0062B",
          type: "color"
        },
        "1000": {
          value: "#AB0120",
          type: "color"
        }
      }
    }
  },
  rahoitu: {
    orange: {
      shade: {
        "100": {
          value: "#FFE4BC",
          type: "color"
        },
        "200": {
          value: "#FFD38E",
          type: "color"
        },
        "300": {
          value: "#FFC46A",
          type: "color"
        },
        "400": {
          value: "#FFB444",
          type: "color"
        },
        "500": {
          value: "#FFA927",
          type: "color"
        },
        "600": {
          value: "#FF9C07",
          type: "color"
        },
        "700": {
          value: "#F29304",
          type: "color"
        },
        "800": {
          value: "#DC8400",
          type: "color"
        },
        "900": {
          value: "#BD7100",
          type: "color"
        },
        "1000": {
          value: "#A16100",
          type: "color"
        }
      }
    }
  }
};
var space = {
  "25": {
    value: "4",
    type: "spacing"
  },
  "50": {
    value: "8",
    type: "spacing"
  },
  "75": {
    value: "12",
    type: "spacing"
  },
  "100": {
    value: "16",
    type: "spacing"
  },
  "150": {
    value: "24",
    type: "spacing"
  },
  "200": {
    value: "32",
    type: "spacing"
  }
};
var size = {
  "50": {
    value: "8px",
    type: "sizing"
  },
  "100": {
    value: "16px",
    type: "sizing"
  },
  "125": {
    value: "20px",
    type: "sizing"
  },
  "150": {
    value: "24px",
    type: "sizing"
  },
  "250": {
    value: "40px",
    type: "sizing"
  },
  "275": {
    value: "44px",
    type: "sizing"
  },
  "300": {
    value: "48px",
    type: "sizing"
  },
  "1200": {
    value: "192px",
    type: "sizing"
  },
  "1300": {
    value: "208px",
    type: "sizing"
  },
  "1500": {
    value: "240px",
    type: "sizing"
  },
  "2000": {
    value: "320px",
    type: "sizing"
  },
  "2200": {
    value: "352px",
    type: "sizing"
  }
};
var font = {
  size: {
    "75": {
      value: "12",
      type: "fontSizes"
    },
    "100": {
      value: "16",
      type: "fontSizes"
    },
    "125": {
      value: "20",
      type: "fontSizes"
    },
    "150": {
      value: "24",
      type: "fontSizes"
    },
    "175": {
      value: "28",
      type: "fontSizes"
    },
    "200": {
      value: "32",
      type: "fontSizes"
    },
    "250": {
      value: "40",
      type: "fontSizes"
    }
  },
  family: {
    roboto: {
      value: "Roboto",
      type: "fontFamilies"
    },
    poppins: {
      value: "Poppins",
      type: "fontFamilies"
    },
    "core-sans-c": {
      value: "Core Sans C",
      type: "fontFamilies"
    },
    "be-vietnam-pro": {
      value: "Be Vietnam Pro",
      type: "fontFamilies"
    },
    lexend: {
      value: "Lexend",
      type: "fontFamilies"
    },
    subjecttivity: {
      value: "Subjectivity",
      type: "fontFamilies"
    },
    Gellix: {
      value: "Gellix",
      type: "fontFamilies"
    }
  },
  weight: {
    regular: {
      value: "Regular",
      type: "fontWeights"
    },
    medium: {
      value: "Medium",
      type: "fontWeights"
    },
    semibold: {
      value: "SemiBold",
      type: "fontWeights"
    },
    bold: {
      value: "Bold",
      type: "fontWeights"
    },
    light: {
      value: "Light",
      type: "fontWeights"
    }
  }
};
var border = {
  width: {
    s: {
      value: "1",
      type: "borderWidth"
    },
    m: {
      value: "2",
      type: "borderWidth"
    },
    l: {
      value: "4",
      type: "borderWidth"
    },
    xl: {
      value: "6",
      type: "borderWidth"
    }
  },
  radius: {
    "25": {
      value: "4",
      type: "borderRadius"
    },
    "50": {
      value: "8",
      type: "borderRadius"
    },
    "100": {
      value: "16",
      type: "borderRadius"
    },
    "150": {
      value: "24",
      type: "borderRadius"
    },
    "200": {
      value: "32",
      type: "borderRadius"
    },
    max: {
      value: "99999",
      type: "borderRadius"
    },
    none: {
      value: "0",
      type: "borderRadius"
    }
  }
};
var tokens = {
  color: color,
  space: space,
  size: size,
  font: font,
  border: border,
  "line-height": {
    "125": {
      value: "20px",
      type: "lineHeights"
    }
  }
};
export { border, color, tokens as default, font, size, space };